define(
    'CommerceCategorySearchResults.CategorySuggestion.View',
    [
        'Backbone.View',
        'category_suggest.tpl',
        'underscore'
    ],
    function(
        BackboneView,
        commercecategorysearchresults_category_suggestion_tpl,
        _
    ) {
        'use strict';

        return BackboneView.extend({
            template: commercecategorysearchresults_category_suggestion_tpl,

            getContext: function getContext() {
                return {
                    name: this.model.get('_name'),
                    url: this.model.get('_url'),
                    breadcrumb: this.model.get('_categoryBreadcrumb'),
                    hasBreadcrumb: !!this.model.get('_categoryBreadcrumb'),
                    currentQuery: _(this.options.query || '').escape()
                };
            }
        });
    }
);
